import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { ArrowDownIcon } from "../../../components/Icons/ArrowDownIcon";
import CheckedIconSelected from "../../../components/Icons/CheckedIconSelected";
import { SORT_TYPE_OPTIONS, SORT_TYPE_PRIME_OPTIONS } from "../../../constants";
import { useEffect } from "react";
import { useApp } from "../../../contexts";

function Sort(props) {
  const { filterData, setFilterData, type } = props;
  const { T } = useApp();
  const sortOptions = useMemo(() => {
    if (type !== 'nft_prime') {
      return SORT_TYPE_OPTIONS
    }else{
      return SORT_TYPE_PRIME_OPTIONS
    }
  }, [type])
  const sortDefault = sortOptions.find(
    (item) => item.value == filterData.sort
  );
  const [show, $show] = useState(false);
  const [sort, $sort] = useState(sortDefault?.value);
  const [title, $title] = useState(T(sortDefault?.text));

  const handleDropdown = () => {
    $show(!show);
  };
  const changeSort = (val) => {
    $sort(val);
    const sortSelected = sortOptions.find((item) => item.value == val);
    $title(sortSelected.text);
    $show(false);
    setFilterData({ sort: val });
  };
  useEffect(() => {
    $title(sortDefault?.text);
    $sort(sortDefault?.value);
  }, [sortDefault]);
  return (
    <div className="relative min-w-[200px] min-lg:w-[247px]">
      <div
        className={
          "flex justify-between items-center py-[6px] px-5 h-[42px] w-full border border-suzu-gray-3 border-solid bg-white rounded-[10px]" +
          (show ? " relative z-20" : "")
        }
        onClick={handleDropdown}
      >
        <span className="text-sm text-black font-medium">{T(title)}</span>
        {show && <ArrowDownIcon className="rotate-180" />}
        {!show && <ArrowDownIcon />}
      </div>
      {show && (
        <div className="absolute left-0 top-0 z-10 w-full rounded-[15px] shadow-lg bg-white pt-14 pb-3">
          {sortOptions.map((item) => {
            return (
              <div
                className="flex justify-between items-center py-2.5 px-5 cursor-pointer"
                onClick={() => changeSort(item.value)}
                key={item.value}
              >
                <span
                  className={
                    "text-base" +
                    (item.value == sort
                      ? " text-aia-red"
                      : " text-suzu-gray-7")
                  }
                >
                  {T(item.text)}
                </span>
                {item.value == sort && <CheckedIconSelected />}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

Sort.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func,
};

export default Sort;
